import {
    get,
    post,
    download
  } from "../utils/http";

  const sensor = {
    list: params => post('/sensor/list',params),
    // getWarningAudio: params => post('/sensor/getWarningAudio',params),
    sensorHistory: params => post('/sensor/sensorHistory',params),
    escalatorHistory: params => post('/sensor/escalatorHistory',params),
    add: params => post('/sensor/add',params),
    edit: params => post('/sensor/edit',params),
    del: params => post('/sensor/del',params),
    getWarningAudio: params => post('/sensor/getWarningAudio',params),
    page: params => post('/sensor/page',params),
    updateTemperWarning: params => post('/sensor/updateTemperWarning',params),
    
  }

  export default sensor;



// WEBPACK FOOTER //
// ./src/api/sensor.js